import React, { useEffect, useState } from "react";
import useLogin from "../hooks/useLogin";
import { checkIfAuthenticated } from "../utils/utils";
import { LOGIN } from "../config/apiConfig";
import { GoAlertFill } from "react-icons/go";
import { AiOutlineLoading } from "react-icons/ai";
import {
  BsArrowUpRight,
  BsCheck2Circle,
  BsGraphUpArrow,
  BsShieldLock,
} from "react-icons/bs";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { loading, error, isLoggedIn, login } = useLogin(LOGIN.POST_LOGIN);

  useEffect(() => {
    if (checkIfAuthenticated() || isLoggedIn) {
      window.location.href = "/dashboard";
    }
  }, [isLoggedIn]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await login(email, password);
    } catch (error) {
      console.log(error.response.data.message);
    }
  };

  const corporateHighlights = [
    {
      icon: <BsShieldLock size={18} />,
      title: "Segurança para crédito empresarial",
      description: "Acesso protegido e rastreabilidade completa nas operações de crédito.",
    },
    {
      icon: <BsGraphUpArrow size={18} />,
      title: "Análise de risco orientada por dados",
      description: "Consolide informações financeiras e acelere a decisão de crédito.",
    },
    {
      icon: <BsCheck2Circle size={18} />,
      title: "Processo corporativo padronizado",
      description: "Esteira unificada para cadastro, análise, aprovação e acompanhamento.",
    },
  ];

  return (
    <main className="mx-login-shell">
      <section className="mx-login-layout">
        <aside className="mx-login-hero" aria-label="Mensagem institucional">
          <div className="mx-hero-noise" />
          <div className="mx-hero-content">
            <p className="mx-hero-eyebrow">AMPLIA CAPITAL</p>
            <h1 className="mx-hero-title">
              Plataforma de crédito empresarial.
            </h1>


            <div className="mx-hero-divider" />

            <div className="mx-hero-metrics" aria-label="Indicadores">
              <article>
                <strong>99.9%</strong>
                <span>Disponibilidade da plataforma</span>
              </article>
              <article>
                <strong>24/7</strong>
                <span>Operação e monitoramento</span>
              </article>
              <article>
                <strong>+18k</strong>
                <span>Consultas de crédito por dia</span>
              </article>
            </div>

            <div className="mx-hero-highlights mt-4" role="list" aria-label="Diferenciais da plataforma">
              {corporateHighlights.map((highlight) => (
                <article key={highlight.title} className="mx-hero-highlight" role="listitem">
                  <span className="mx-hero-highlight-icon">{highlight.icon}</span>
                  <div>
                    <h3>{highlight.title}</h3>
                    <p>{highlight.description}</p>
                  </div>
                </article>
              ))}
            </div>

            <img
              src="/assets/logo-white.png"
              className="mx-hero-logo"
              loading="lazy"
              alt="Amplia Capital"
            />
          </div>
        </aside>

        <section className="mx-login-form-side">
          <div className="mx-form-card">
            <p className="mx-form-eyebrow">ACESSO RESTRITO</p>
            <h2 className="mx-form-title">Entrar na plataforma</h2>
            <p className="mx-form-subtitle">
              Informe suas credenciais para acessar o ambiente de crédito empresarial.
            </p>

            <form className="mx-form" onSubmit={handleSubmit}>
              <div className="mx-field">
                <label htmlFor="email">E-mail / Cód. de acesso</label>
                <input
                  type="text"
                  name="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoComplete="username"
                />
              </div>

              <div className="mx-field">
                <label htmlFor="password">Senha</label>
                <input
                  type="password"
                  name="password"
                  id="password"
                  placeholder="Digite sua senha"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  autoComplete="current-password"
                />
              </div>

              {error && (
                <div className="mx-error-alert" role="alert">
                  <GoAlertFill />
                  <span>
                    {error?.response?.data?.message ||
                      "Erro ao tentar realizar o login."}
                  </span>
                </div>
              )}

              <div className="mx-form-actions">
                <a href="#" className="mx-forgot-link">
                  Esqueceu a senha?
                </a>
              </div>

              <button type="submit" className="mx-submit-button" disabled={loading}>
                {loading ? (
                  <>
                    <AiOutlineLoading className="mx-spinner" />
                    Validando acesso...
                  </>
                ) : (
                  <>
                    Entrar
                    <BsArrowUpRight size={16} />
                  </>
                )}
              </button>
            </form>

            <p className="mx-footnote">
              Plataforma monitorada para operações de crédito empresarial.
            </p>
          </div>
        </section>
      </section>
    </main>
  );
};

export default LoginPage;
